export default "__VITE_ASSET__BSxIrMRc__"